import React, { useState } from "react";

import { STRING } from "@constants";
import {
  useAllLocations,
  useAllUnitDescription,
  useRemoveUnitDescriptionById,
  useUnitsDescriptionByLocation,
} from "@api";
import { GenericDeleteDialog, GenericDetailsModal, Table } from "@components";

import { getSizesDetails } from "./getSizesDetails";
import { useGetUnitDescription } from "./useGetUnitDescription";
import { useManageUnitDescription } from "./useManageUnitDescription";
import { UnitDescriptionSideBar } from "./UnitDescriptionSideBar";
import { Dropdown } from "primereact/dropdown";

const T = STRING.SIZE_DETAILS;

export function UnitDescription() {
  const { data: location } = useAllLocations();

  const [filterCategory, setFilterCategory] = useState<string | null>(null);

  const unitsDescription = useAllUnitDescription();
  const unitsDescriptionByLocation = useUnitsDescriptionByLocation(
    filterCategory ?? "",
    10,
  );

  const activeHook = filterCategory
    ? unitsDescriptionByLocation
    : unitsDescription;

  const { data, loading, loadMore, hasMore } = activeHook;

  const { removeUnitDescription } = useRemoveUnitDescriptionById();

  const {
    selectedSize,
    toggleSideBar,
    isSideBarOpen,
    selectSizeToEdit,
    isDetailsModalOpen,
    handleCloseDetailsModal,
    handleRowClick,
    unitDescriptionToDeleteId,
    handleCloseDeleteDialog,
    handlePressDeleteButton,
  } = useManageUnitDescription();

  const { columns } = useGetUnitDescription({
    onEdit: selectSizeToEdit,
    onDelete: handlePressDeleteButton,
  });

  const { sections } = getSizesDetails(selectedSize);

  const handleDelete = async () => {
    await removeUnitDescription(unitDescriptionToDeleteId);
  };

  return (
    <div className="overflow-hidden">
      <UnitDescriptionSideBar
        show={isSideBarOpen}
        editValues={selectedSize}
        onClose={toggleSideBar}
      />

      <GenericDeleteDialog
        visible={unitDescriptionToDeleteId !== ""}
        onClose={handleCloseDeleteDialog}
        onDelete={handleDelete}
        texts={{
          header: T.CONFIRM_DELETE,
          warning: T.DELETE_WARNING,
          success: T.DELETE_SUCCESS,
          error: T.DELETE_ERROR,
        }}
      />

      <GenericDetailsModal
        visible={isDetailsModalOpen}
        onHide={handleCloseDetailsModal}
        sections={sections}
        header={T.MODAL_HEADER}
        noDataText={T.NO_DATA}
      />

      <Table
        columns={columns}
        data={data}
        title="Unit Description"
        onAddNew={toggleSideBar}
        onRowClicked={handleRowClick}
        loading={loading}
        loadMore={hasMore ? loadMore : undefined}
        extraHeader={
          <div className="flex align-items-center gap-3">
            <span className="font-medium text-color">Filter by Location:</span>

            <Dropdown
              value={filterCategory}
              options={[
                ...(location || []).map((c) => ({
                  label: c.locationName,
                  value: c.id,
                })),
              ]}
              showClear
              onChange={(e) => {
                setFilterCategory(e.value);
              }}
              placeholder="Filter by Location"
              className="w-40"
            />
          </div>
        }
      />
    </div>
  );
}
